'use client';
import React from 'react';

interface ToolHeaderProps {
    icon: React.ReactNode;
    iconColor: string;
    title: string;
    description: string;
    category: string;
}

const tagVariants: Record<string, string> = {
    method: 'bg-purple-soft text-purple-ink',
    visualiser: 'bg-teal-soft text-teal-ink',
    reference: 'bg-amber-soft text-amber-ink',
};

const tagBase =
    'inline-flex items-center px-2 py-0.5 rounded-sm text-[11px] font-medium uppercase tracking-[0.02em] capitalize';

export default function ToolHeader({
    icon,
    iconColor,
    title,
    description,
    category,
}: ToolHeaderProps) {
    const tagClass = tagVariants[category] ?? 'bg-subtle text-hint';

    return (
        <header className="flex items-center justify-between gap-4 border-b-[0.5px] border-line bg-white p-4 sm:p-6">
            <div className="flex min-w-0 items-center gap-4">
                <div
                    className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-md text-[20px]"
                    style={{
                        background: `var(--color-${iconColor}-soft)`,
                        color: `var(--color-${iconColor})`,
                    }}
                >
                    {icon}
                </div>
                <div className="min-w-0">
                    <h1 className="mb-0.5 text-lg font-medium">{title}</h1>
                    <p className="text-sm text-muted">{description}</p>
                </div>
            </div>
            <span className={`${tagBase} ${tagClass} shrink-0`}>{category}</span>
        </header>
    );
}
